export default __webpack_public_path__ + "static/media/cwye-unique-condiments-sauces-vegshelf.eed6d9f2.png";